module.exports = __webpack_public_path__ + "650be7bf6524161dd3fbf6715ac19867.svg";